import { Logger } from './logger';

export let logger: Logger;

export const setDefaultLogger = (newLogger: Logger) => {
	logger = newLogger;
};
